/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=3238a189"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3238a189&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__